import { Box, Text } from '@chakra-ui/react';

export default function Footer() {
  return (
    <Box
      as='footer'
      w='full'
      h='28px'
      overflow='hidden'
      bg='white'
      borderTop='1px solid'
      borderColor='bg.muted'
    >
      <Text fontSize='xs' textAlign='right' px='4' py='1'>
        University of <strong>Saskatchewan</strong>
      </Text>
    </Box>
  );
}
